import {List, Col, Form, Input, Row, Select, Button, Avatar, Tag} from "antd";
import React from "react";
import {addBranch, updateGeneral} from "../../Store/Actions/shop";
import {compose} from "redux";
import {firestoreConnect} from "react-redux-firebase";
import {connect} from "react-redux";
const { Option } = Select;
const rules = [{ required: true }];


class Branches extends React.Component {

    state = {
        logoUrl: this.props.shop.logo,
        backgroundUrl: this.props.shop.background,
        logoList: [],
        backgroundList: [],
        uploading: false,
        current: 0,
    };

    onDelete = faq => {

    }

    onFinish = values => {
        this.setState({
            uploading: true
        })
        let files = {};
        if(this.state.backgroundList.length > 0){
            files.background = this.state.backgroundList[0];
        }
        if(this.state.logoList.length > 0){
            files.logo = this.state.logoList[0];
        }
        const { shop } = this.props;
        addBranch(shop.id, values, res => {
            this.setState({
                uploading: false
            })
        })
    };


    render() {
        const { uploading, logoList, backgroundList, backgroundUrl, logoUrl, current } = this.state;
        const { branches } = this.props;

        return (
            <div>
                <div className="uk-padding">
                    <div className="uk-margin-bottom">
                        <div>
                            <h3 className="uk-h3 uk-margin-remove uk-text-bolder">
                                Shop branches
                            </h3>
                            <p className="uk-text-small uk-margin-remove">
                                4 branches
                            </p>
                        </div>
                    </div>
                    <Row gutter={32}>
                        <Col span={12}>
                            <div>
                                <div>
                                    <List
                                        itemLayout="horizontal"
                                        dataSource={branches}
                                        renderItem={item => (
                                            <List.Item>
                                                <List.Item.Meta
                                                    title={
                                                        <span>{item.address}</span>
                                                    }
                                                    description={
                                                        <span>
                                                            <i className="fas fa-location-arrow" /> {item.city}
                                                        </span>
                                                    }
                                                />
                                            </List.Item>
                                        )}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div>
                                <Form onFinish={this.onFinish}>
                                    <h3 className="uk-h4">
                                        New Branch
                                    </h3>
                                    <Row gutter={[8, 0]}>
                                        <Col span={6}>
                                            <Form.Item
                                                name={"city"}
                                                rules={rules}
                                            >
                                                <Input placeholder="City" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={16}>
                                            <Form.Item
                                                name={"address"}
                                                rules={rules}
                                            >
                                                <Input placeholder="Address" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                name={"latitude"}
                                            >
                                                <Input placeholder="Latitude" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                name={"longitude"}
                                            >
                                                <Input placeholder="Longitude" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Form.Item>
                                        <Button disabled={uploading} loading={uploading} type="primary" size="large" htmlType="submit">
                                            Add branch
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }

}


const mapStateToProps = (state, props) => {

    return {
        auth: state.firebase.auth,
        branches: state.firestore.ordered.branches ? state.firestore.ordered.branches : [],
        ...props
    }
}

const enhance = compose(
    firestoreConnect((props) => [
        { collection: "shops/" + props.shop.id + "/branches", storeAs: "branches" }
    ]),
    connect(mapStateToProps)
);
export default enhance(Branches);



// WEBPACK FOOTER //
// ./src/Components/Shop/Branches.js